import Vue from 'vue';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-the-mask.js
// module id = ./src/plugins/vue-the-mask.js
// module chunks = 34